import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";


type Props = {
  onActionEditar: ( Id: number | null, openState: boolean) => void,
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
};

export const GenerateQualidadeItemProcessosFatorColumns = ({
  onActionEditar,onActionDeletar,
}: Props): GridColDef[] => {

  //#region  Ocorrencia
   const computeItemOcorrenciaTitle = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "Baixa";
      case 1:
        return "Média";
      case 2:
        return "Alta";
      case 3:
        return "Não se aplica";
      default:
        return "?";
    }
  };
  const computeItemOcorrenciaColor = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "blue";
      case 1:
        return "yellow";
      case 2:
        return "red";
      case 3:
        return "green";
      default:
        return "green";
    }
  };
  // #endregion

    //#region  InternoExterno
   const computeInternoExternoTitle = (tipo: string) => {
    switch (tipo) {
      case "Interno":
        return "Interno";
      case "Externo":
        return "Externo";
      default:
        return "Não identificado";
    }
  };
  const computeInternoExternoColor = (tipo: string) => {
    switch (tipo) {
      case "Interno":
        return "green";
      case "Externo":
        return "yellow";
      default:
        return "green";
    }
  };

  //#endregion

  //#region  RiscoOportunidade
   const computeItemRiscoOportunidadeTitle = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "Risco";
      case 1:
        return "Oportunidade";
      default:
        return "?";
    }
  };
  const computeItemRiscoOportunidadeColor = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "red";
      case 1:
        return "green";
      default:
        return "yellow";
    }
  };

  //#endregion
  
  //#region  Impacto
   const computeItemImpactoTitle = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "Baixa";
      case 1:
        return "Média";
      case 2:
        return "Alta";
      case 3:
        return "Não se aplica";
      default:
        return "?";
    }
  };
  const computeItemImpactoColor = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "blue";
      case 1:
        return "yellow";
      case 2:
        return "red";
      case 3:
        return "green";
      default:
        return "green";
    }
  };

  //#endregion

  return [
    {
      field: "FatorRisco", 
      filterable: false,
      headerName: "Evento", 
      flex: 1, 
      minWidth: 160,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "RiscoOportunidade",
      filterable: false,
      headerName: "Risco / Oportunidade",
      width: 140,
      sortable: false,
       renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemRiscoOportunidadeTitle(params.value)}
            color={computeItemRiscoOportunidadeColor(params.value)}
            description=""/>
        </div>
      )
    },
    {
      field: "IternoExterno",
      filterable: false,
      headerName: "Interno / Externo",
      width: 126,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center">
            <LargeItemStatus
              title={computeInternoExternoTitle(params.value)}
              color={computeInternoExternoColor(params.value)}
              description=""/>
        </div>
        );
      },
    },
    {
      field: "Consequencia",
      filterable: false,
      headerName: "Consequências e Impactos",
      flex: 1, 
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Ocorrencia",
      filterable: false,
      headerName: "Probabilidade de ocorrência",
      width: 140,
      sortable: false,
       renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemOcorrenciaTitle(params.value)}
            color={computeItemOcorrenciaColor(params.value)}
            description=""/>
        </div>
      )
    },
    {
      field: "Impacto",
      filterable: false,
      headerName: "Impacto",
      width: 120,
      sortable: false,
       renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemImpactoTitle(params.value)}
            color={computeItemImpactoColor(params.value)}
            description=""/>
        </div>
      )
    },
    {
      field: "Oportunidade",
      filterable: false,
      headerName: "Ação preventiva / imediata ",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Acao",
      filterable: false,
      headerName: "Ação de contingência / futuras",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },  
    },
    {
      field: "Acompanhamento",
      filterable: false,
      headerName: "Resultados alcançados",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
    field: 'IdItemProcessoFator',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    width: 100,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}